// Mobile web view deeplink for signin
export const SIGN_IN_DEEPLINK = 'tunein://regwall/?source=webbilling';
